import { Controller } from "stimulus";

// A two-level checkbox tree for choosing which payer profile sections a portal
// shows and which fields sit inside each one.
//
// The section checkbox is a roll-up of its fields: ticking it takes all of
// them, unticking it drops all of them, and a partial selection shows as
// indeterminate. A section with no fields of its own (Enrollment, which lists
// metrics) simply has nothing to roll up.
export default class extends Controller {
  static targets = ["section", "field", "count"];

  connect() {
    this.refresh();
  }

  // Section checkbox clicked: push its state down to every field under it.
  toggleSection(event) {
    const section = event.target.closest("[data-section-id]");

    this.fieldsFor(section).forEach(field => {
      field.checked = event.target.checked;
    });

    this.refresh();
  }

  // Field checkbox clicked: pull the section checkbox up to match.
  toggleField() {
    this.refresh();
  }

  refresh() {
    this.sectionTargets.forEach(sectionCheckbox => {
      const section = sectionCheckbox.closest("[data-section-id]");
      const fields = this.fieldsFor(section);
      const checked = fields.filter(field => field.checked);

      if (fields.length > 0) {
        sectionCheckbox.checked = checked.length > 0;
        sectionCheckbox.indeterminate = checked.length > 0 && checked.length < fields.length;
      }

      this.updateCount(section, checked.length, fields.length);
    });
  }

  updateCount(section, checked, total) {
    const count = this.countTargets.find(target => target.closest("[data-section-id]") === section);

    if (!count || total === 0) return;

    count.textContent = `${checked} of ${total}`;
  }

  fieldsFor(section) {
    return this.fieldTargets.filter(field => field.closest("[data-section-id]") === section);
  }
}
